<template>
  <path pid="0" d="M23.86 11.5v-.14-.07a.13.13 0 010-.06V5a1 1 0 00-1-1h-.12A1 1 0 0022 5v3.68l-2.95-2.77a10 10 0 102.38 10.42 1 1 0 10-1.88-.66A8 8 0 118.14 6l.25-.14a8 8 0 019.27 1.49L20.48 10H17a1 1 0 000 2h6.33a1 1 0 00.3-.19.38.38 0 00.09-.12zM13.05 13zM13 13z"/>
</template>
